import { CORE_ACTIONS } from '../../core/constants/core-actions.constant';
import { IConfigurationState } from './configuration.state';
import { ConfigurationActions, TConfigurationActions } from './configuration.actions';
import {IResource} from "@ispm/core/interfaces/resource.interface";

export const initState: IConfigurationState = {
  definitions: new Map<string, Map<string, IResource>>(),
  activeConfig: new Map<string, IResource>()
};

export function ConfigurationReducer(state: IConfigurationState = initState, action: TConfigurationActions): IConfigurationState {
  let existingState: IConfigurationState;
  let payload;
  switch (action.type) {
    case ConfigurationActions.StartFetching:
    case ConfigurationActions.Reset:
      return initState;
    case ConfigurationActions.Set:
      existingState = Object.assign(state);
      payload = action.payload.getValue() as any;
      if(payload) {
        let s:Map<string, IResource> =  existingState.definitions.get(payload.resourceType) || new Map<string, IResource>() ;
        s.set(payload.resource.id,payload.resource);
        existingState.activeConfig = new Map(existingState.activeConfig);
        existingState.activeConfig.set(payload.resourceType,payload.resource)
        existingState.definitions = new Map(existingState.definitions);
        existingState.definitions.set(payload.resourceType, s);
      }
      return { ...existingState};

    case ConfigurationActions.Clear:
      existingState = Object.assign(state);
      payload = action.payload.getValue() as any;
      if(payload && payload.resourceToClear) {
        existingState.definitions.delete(payload.resourceToClear);
      }
      return existingState;

    default:
      return state;
  }
}
